import { render, staticRenderFns } from "./GridMenu.vue?vue&type=template&id=21b5edd2&"
import script from "./GridMenu.vue?vue&type=script&lang=js&"
export * from "./GridMenu.vue?vue&type=script&lang=js&"
import style0 from "./GridMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports